let treeHelper = require('../../helpers/tree');
const DEFAULT_MIN_LENGTH = 4;

module.exports = {
    initTreeState ({ basePath, srcDataPath }, state) {
        treeHelper.initTreeUiState(state, srcDataPath, basePath);
    },

    switchSubTreeCollapse ({ basePath, nodeId }, state) {
        let fullPath = basePath.concat('expanded', nodeId);
        let value = state.get(fullPath);
        state.set(fullPath, !value);
    },

    switchSubTreeCollapseCustom ({ basePath, nodeId, collapseType }, state) {
        let fullPath = basePath.concat(collapseType, nodeId);
        let value = state.get(fullPath);
        state.set(fullPath, !value);
    },

    setFilter ({ basePath, value, minLength }, state) {
        let minFilterLength = minLength || DEFAULT_MIN_LENGTH;
        let path = basePath.concat('filter');

        let currentValue = state.get(path);
        if (value.length >= minFilterLength) {
            state.set(path, value);
        } else if (currentValue !== null) {
            state.set(path, null);
        }
    },

    setShowSelectedOnly ({ basePath, showSelectedOnly, treeId }, state) {
        let path = basePath.concat('showSelectedOnly');
        let value = showSelectedOnly;
        if (showSelectedOnly === undefined) {
            value = !state.get(path);
        }
        state.set(path, value);

        //если пользователь кликнул "Показать отмеченные", то очищаем фильтр
        state.set(basePath.concat('filter'), null);
        let htmlInput = document.getElementById(treeId+'Filter');
        if (htmlInput) {
            htmlInput.value = '';
        }
    },

    // в html-input вставляем значение фильтра из нашего дерева
    initFilter ({ basePath, treeId }, state) {
        var value = state.get(basePath.concat('filter'));
        if (value) {
            document.getElementById(treeId+'Filter').value = value;
        }
    },

    changeValue ({ basePath, srcDataPath, nodeId, value }, state) {
        treeHelper.changeTreeNodeValue(
            state,
            srcDataPath,
            basePath,
            nodeId,
            value);
    }
};



// WEBPACK FOOTER //
// ./actions/custom-order/filterable-tree.js